<template>
  <div>
    <div class="info">
      <!-- 共有属性: {客户名称} {客户类型} -->
      <el-row>
        <el-col :span="12">
          <el-col :span="7">
            <div class="info-title">客户类型：</div>
          </el-col>
          <el-col :span="16">
            <div
              class="info-detail"
              v-text="commonCustomer && commonCustomer.categoryName"
            ></div>
          </el-col>
        </el-col>
      </el-row>
      <!-- 普通客户 -->
      <div
        v-if="commonCustomer.categoryUid !== 'ed67aad9552b4f1b8520785b9cb4bfd1'"
      >
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">客户名称：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ commonCustomer && commonCustomer.name }}
                {{ commonCustomer && commonCustomer.depaName }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-col :span="7">
              <div class="info-title">统一社会信用代码：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.creditCode }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">注册资金：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.commonCustomer.capital }} 万元
              </div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">规模：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.commonCustomer.scale }} 人
              </div>
            </el-col>
          </el-col>
        </el-row>
      </div>
      <!-- 医院 -->
      <div
        v-if="commonCustomer.categoryUid === 'ed67aad9552b4f1b8520785b9cb4bfd1'"
      >
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">客户名称：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.commonCustomer.name }}
              </div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">跟进状态：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.followUpStateName }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">医院等级：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.hospitalLevelName }}
              </div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">病床数：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.sickbedNumber }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">覆盖人口(万)：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.coverPopulation }}
              </div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">当地医院排名：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.hospitalRhanking }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">年收入(万)：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.annualIncome }}
              </div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">职工人数：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.employeeNumber }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">年门诊人次(万)：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.outpatientVisits }}
              </div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">合作科室：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ oprationDepartment.join(',') }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">年住院人次(万)：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.hospitalizationVisits }}
              </div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">负债率：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">{{ customInfo.liabilities }}%</div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">医疗设备：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.medicalEquipment === 1 ? '有' : '无' }}
              </div>
            </el-col>
          </el-col>
          <el-col :span="12" v-if="customInfo.medicalEquipment === 1">
            <el-col :span="7">
              <div class="info-title">设备总金额(万元)：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.deviceAmount }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="customInfo.medicalEquipment === 1">
          <el-col :span="24">
            <el-col :span="3">
              <div class="info-title">设备名称：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.deviceName }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="7">
              <div class="info-title">耗材：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.consumables === 1 ? '有' : '无' }}
              </div>
            </el-col>
          </el-col>
          <el-col :span="12" v-if="customInfo.consumables === 1">
            <el-col :span="7">
              <div class="info-title">耗材流水(万元/年)：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.consumablesRunningWater }}
              </div>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="customInfo.medicalEquipment === 1">
          <el-col :span="24">
            <el-col :span="7">
              <div class="info-title">备注：</div>
            </el-col>
            <el-col :span="16">
              <div class="info-detail">
                {{ customInfo.customerRemarks }}
              </div>
            </el-col>
          </el-col>
        </el-row>
      </div>
      <!-- 共有属性: {客户地区} -->
      <el-row>
        <el-col :span="24">
          <el-col :span="2">
            <div class="info-title">客户地区：</div>
          </el-col>
          <el-col :span="22">
            <div class="info-detail">
              {{ customInfo.commonCustomer.province }}
              {{ customInfo.commonCustomer.city }}
              {{ customInfo.commonCustomer.district }}
            </div>
          </el-col>
        </el-col>
      </el-row>
      <!-- 共有属性: {详细地址} -->
      <el-row>
        <el-col :span="24">
          <el-col :span="2">
            <div class="info-title">详细地址：</div>
          </el-col>
          <el-col :span="22">
            <div class="info-detail">
              {{ customInfo.streetAddress }}
            </div>
          </el-col>
        </el-col>
      </el-row>
      <!-- 共有属性: {业务员} -->
      <el-row>
        <el-col :span="24">
          <el-col :span="2">
            <div class="info-title">业务员：</div>
          </el-col>
          <el-col :span="22">
            <div class="info-detail">
              {{ customInfo.commonCustomer.salesmanName }}
            </div>
          </el-col>
        </el-col>
      </el-row>
      <!-- 共有属性: {联系人} -->
      <el-row>
        <el-col :span="12">
          <el-col :span="7">
            <div class="info-title">联系人：</div>
          </el-col>
        </el-col>
      </el-row>
      <el-table
        :data="customContacts.results"
        :border="true"
        style="width: 100%"
      >
        <el-table-column prop="name" align="center" label="姓名">
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="联系方式">
        </el-table-column>
        <el-table-column prop="typeName" align="center" label="类型">
        </el-table-column>
        <el-table-column prop="duty" align="center" label="职务">
        </el-table-column>
        <el-table-column prop="contactDepa" align="center" label="部门">
        </el-table-column>
        <el-table-column prop="contactEmail" align="center" label="邮箱">
        </el-table-column>
      </el-table>
      <!-- 可配置项: {审核备注} -->
      <el-row v-if="isShowRemark">
        <el-col :span="24">
          <el-col :span="2">
            <div class="info-title">审核备注：</div>
          </el-col>
          <el-col :span="22">
            <div
              class="info-detail"
              v-text="commonCustomer && commonCustomer.remark"
            ></div>
          </el-col>
        </el-col>
      </el-row>
      <!-- 可自定义插槽 -->
      <el-row>
        <el-col :span="24">
          <slot :common-customer="commonCustomer"></slot>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    customInfo: Object,
    customContacts: Object,
    // 共有客户属性: uid, name, categoryName, type, categoryUid, province, city, district,
    commonCustomer: Object,

    // 共有联系人属性: name, mobile, duty, type
    crmCustomerContact: Object,

    // 医生专属，type = 2
    hospital: String,
    department: String,
    doctorTitle: String,
    remark: String,

    // 医院专属，type = 3
    hospitalLevel: String,

    // 公司专属，type = 1 || 3
    businessLicenseNum: String,
    organizationCode: String,
    creditCode: String,
    streetAddress: String,

    // 是否需要显示`审核备注`
    isShowRemark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      contactsType: 'common/contactsType',
    }),
    // 联系人名称，根据props属性的crmCustomerContact.type值，从业务员类型列表里取出
    contactName() {
      if (!this.crmCustomerContact || !this.crmCustomerContact.type) return '';
      return (
        this.contactsType
        && this.contactsType.results.find(
          contact => contact.uid === this.crmCustomerContact.type,
        ).name
      );
    },
    oprationDepartment() {
      const deparment = [];
      this.customInfo.customerDetail.forEach((item) => {
        deparment.push(item.dictName);
      });
      return deparment;
    },
  },
  created() {
    if (this.contactsType && this.contactsType.results) return;
    this.getContactsType({
      code: 'category_contact',
    });
  },
  methods: {
    ...mapActions({
      getContactsType: 'common/getContactsType',
    }),
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';

.info {
  padding: 10px 80px;
  .info-title {
    height: 40px;
    line-height: 40px;
    color: #2c3e50;
    font-weight: 500;
    text-align: left;
    padding: 8px 0;
  }
  .info-detail {
    height: 40px;
    line-height: 40px;
    padding: 8px 0;
    font-size: 14px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .info-desc {
    font-size: 14px;
    font-weight: 400;
    padding: 8px 0;
    line-height: 28px;
    &.padding-lf-15 {
      padding-left: 15px;
    }
  }
}
</style>
